import { axios } from '@/plugins/http-axios';
import { Module } from 'vuex';
import { IAddressValue } from '@ifr/form-questionnaire/src/types/Elements';
import QuestConfig, { IQuestConfig } from '@ifr/form-questionnaire/src/types/config';
import Url from '@ifr/form-questionnaire/src/types/url';

export interface IStatus {
  id: number;
  code: string;
  name: string;
  message: string;
  messageError: string;
  final: boolean;
}
class Status implements IStatus {
  id: number;
  code: string;
  name: string;
  message: string;
  messageError: string;
  final: boolean;
  constructor({ id = 0, code = '', name = '', message = '', messageError = '', final = false } = {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.message = message;
    this.messageError = messageError;
    this.final = final;
  }
}
interface IApp {
  id: string;
  createDate: string;
  number: string;
  regaddressObject: IAddressValue;
  /*
            "regaddressObject": {
                "text": string|null,
                "value": {}|null
            },
    */
  mapRegaddress: string | null;
  actualaddress: string | null;
  regdate: string | null;
  orgnameshort: string | null;
  orgnamefull: string | null;
  inn: string;
  kpp: string | null;
  ogrn: string | null;
  okpo: string | null;
  legalform: string | null;
  isIndividual: boolean;
  okvedname: string | null;
  office: number | null;
  ownershipform: string | null;
  clientStatus: string | null;
  isAuto: boolean;
  shortNumber: string
  status: string
}
interface IResponseApp {
  data: IApp;
  status: string;
  message: string | null;
}
interface IAppState {
  app: IApp;
  status: string;
}
export default <Module<IAppState, any>>{
  state: {
    app: {
      id: '',
      createDate: '',
      number: '',
      regaddress: '',
      regaddressObject: {
        text: '',
        value: {},
      },
      mapRegaddress: null,
      actualaddress: '',
      regdate: '',
      orgnameshort: '',
      orgnamefull: '',
      inn: '',
      kpp: '',
      ogrn: '',
      okpo: '',
      legalform: null,
      isIndividual: false,
      okvedname: '',
      office: 0,
      ownershipform: '',
      clientStatus: '',
      isAuto: false,
      shortNumber: '',
      status: '',
    },
    status: '',
  },
  mutations: {
    setOfficeId(state, officeId = 0) {
      state.app.office = officeId;
    },
    setAppId(state, id = '') {
      state.app.id = id;
      state.app.shortNumber = id
    },
    setAppFields(state, fields: any) {
      state.app.orgnameshort = fields.orgnameshort;
      state.app.regaddressObject = fields.regaddressObject;
      state.app.regdate = fields.regdate;
    },
    setApp(state, data: IApp = <IApp>{}) {
      for (let key in data) {
        //@ts-ignore
        state.app[key] = data[key];
      }
      state.status = data.status;
    },
    //Этот метод используется при работе с текущей заявкой. Нужен для работы со ссылкой на объект заявки из списка заявок. Для того тчобы в журнале заявок также менялся статус.
    changeAppStatus(state, data: string) {
      state.status = data
      // const status = new Status(data);
      // for (let key in status) {
      //   //@ts-ignore
      //   state.status[key] = status[key];
      // }
    },
  },
  actions: {
    async getApp({ getters, dispatch, rootGetters }, id: string) {
      if (!id) return Promise.reject();

      // if (getters.isApp && getters.appId == id) return Promise.resolve();

      const url = rootGetters.uri.appById(id);
      try {
        const response = await axios.get<IResponseApp>(url)
        dispatch('setApp', response.data);
        return response;
      } catch (error) {
        return Promise.reject(error)
      }
      // const response = await axios.get<IResponseApp>(url)
      // dispatch('setApp', response.data);
      //   .then((resp) => {
      //     return dispatch('setApp', resp.data);
      //   })
      //   .catch((e) => {
      //     //Заявка не найдена
      //     if (e.response?.status === 400) return Promise.reject(e);

      //     e.uri = url;
      //     dispatch('setError', e);
      //     return Promise.reject(e);
      //   });
    },
    // createRequest
    setApp({ commit, dispatch}, app: IResponseApp): Promise<void> {

      dispatch('unlockApp');
      commit('setApp', app.data);
      commit('changeAppStatus', app.status);
      commit('setAppStep', 2);

      localStorage.setItem('appId', app.data?.id || '');

      return Promise.resolve();
    },
    async getAppStatus({ getters, commit, dispatch, rootGetters }, id = getters.appId): Promise<void> {
      return axios
        .get(rootGetters.uri.status(id))
        .then((resp) => {
          commit('changeAppStatus', resp.data);
          return Promise.resolve();
        })
        .catch((e) => {
          e.uri = rootGetters.uri.status(id);
          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
    async unlockApp({ dispatch, rootGetters }) {
      const appId = localStorage.getItem('appId');

      if (!appId)
        return Promise.resolve();

      const url = rootGetters.uri.resetClient(appId);
      return axios
        .post(url)
        .catch((e) => {
          e.uri = url;
          dispatch('setError', e);
        })
        .finally(() => {
          return Promise.resolve();
        })
    },
  },
  getters: {

    isApp: (state): boolean => !!state.app.id,
    app: (state): IApp => state.app,
    appId: (state): string => state.app.id,
    getAppShortNumber: ({ app }) => app.shortNumber,
    appStatusCode: (state): string => state.status,
    isSendingDocs(state, getters): boolean {
      return getters.appStatusCode == 'Загрузка документов';
    },
    isAddDocs(state, getters): boolean {
      return getters.appStatusCode == 'Запрос доп документов';
    },
    isStep3(state, getters): boolean {
      return getters.isSendingDocs || getters.isAddDocs;
    },

    isIndividual: (state): boolean => state.app.isIndividual,
    isAuto: (state): boolean => state.app.isAuto,
    isAppStatusDenied: (state, getters): boolean => getters.isStatusDenied(getters.appStatusCode),
    isStatusDenied:
      (state) =>
        (code: string): boolean => {
          switch (code) {
            case 'Аннулирована клиентом':
            case 'Отказано банком':
            case 'Аннулировано банком':
            case 'Закрыта банком':
              return true;
            default:
              return false;
          }
        },
    isAppStatusAllowed: (state, getters): boolean => getters.isStatusAllowed(getters.appStatusCode),
    isStatusAllowed:
      (state) =>
        (code: string): boolean =>
          code == 'Счет открыт',
    config: (state, getters, rootState, rootGetters): IQuestConfig => {
      // не вызывать запрос на bankOffice для данного кабинета
      return new QuestConfig({
        isIndividual: getters.isIndividual,
        isAutomaticApp: getters.isAuto,
        appRegAddress: state.app.regaddressObject,
        appInn: state.app.inn,
        appId: getters.appId,

        isHideOffice: rootGetters.env.HIDE_OFFICE,
        isHideInvitedManager: rootGetters.env.HIDE_INVITED_MANAGER,
        isHideButtonAddParticipants: rootGetters.env.HIDE_ADD_PARTICIPANT,
        isPassportRecognition: rootGetters.env.PASSPORT_RECOGNITION,
        isWorkingWithNonResidents: rootGetters.env.WORKING_WITH_NON_RESIDENTS,
        minCountCounterparties: +rootGetters.env.MIN_NUMBER_COUNTERPARTIES,

        listRegions: rootGetters['step2/bankingRegions'],

        url: new Url({
          recognitionPassport: rootGetters.uri.recognitionPassport(getters.appId),
          addParticipant: rootGetters.uri.participantOfApp.bind(rootGetters.uri),
        }),

        voc: rootGetters.voc,
        clientPhone: rootGetters.userPhone,
        clientEmail: rootGetters.user.email,
        environment: rootGetters.isLkpMode ? 'LKP' : 'LKK',
        baseUrl: axios.defaults.baseURL,
        isOldMode: !rootGetters.env.IS_NEW_QUESTIONNAIRE_MODE,
      });
    },
  },
};
